module.exports = __webpack_public_path__ + "img/plug.0dd24f45.svg";